<ng-container *ngIf="!isSPOEEnabled">
<div *ngIf="isDashboardVisible">

  <app-notice-banner *ngFor="let noticeBanner of noticeBanners;let i=index"
    [isVisible]="bannersVisibility[i]"
    [noticeBanner]="noticeBanner"
    [isExternalUrl]="isCancelled"
    [isPrimary]="isPrimary"
   >
  </app-notice-banner>
  <app-dashboard-hero
    [disableAccount]="(isExpired || isCancelled) && !cancelledOrExpiredHasFullAccess"
    [notifyPhonesPending]="isPhonesStatusPending"
    [notifyPhonesFailed]="isPhonesStatusFailed">
  </app-dashboard-hero>
  <pgh-upgrade-callout *ngIf="isPTPO" [upgradeBanner]="upgradeBanner"></pgh-upgrade-callout>
  <div class="dashboard-container container">
    <div class="row cards-container">
      <div class="col-lg-7">
        <div
          class="device-main-container"
          tabIndex="0"
          (keypress)="handleMyDevicesKeyDown($event)"
          style="display: flex; padding-right: 16px; height: 100%"
          (click)="goToMyDevices()"
          [gtmClick]="getViewLabel('Dashboard_Devices_Heading')"
          [gtmLinkURL]="deviceRoute">
          <div style="display: flex; align-items: center">
            <!-- PGH Only -->
            <ng-container *ngIf="!isMobilePlan">
              <div *ngIf="isPhonePlanSupported">
                <app-pending-test [totalPendingTest]="1"></app-pending-test>
                <app-connected-devices></app-connected-devices>
              </div>
              <div *ngIf="!isPhonePlanSupported">
                <ng-container *ngIf="!isMobilePlan">
                  <div class="d-flex pt-2 pb-2 pl-2 pr-0">
                    <div class="d-flex">
                      <div class="d-flex flex-column align-items-center">
                        <div class="main-card-container">
                          <div style="display: flex">
                            <div class="w-100" style="display: flex">
                              <table class="w-100">
                                <tbody>
                                  <tr>
                                    <td class="u-heading-4 pt-2 pb-2">
                                      <adp-label labelKey="Dashboard_Devices_Heading"></adp-label>&nbsp;[{{ smartDevicesCount }}]
                                    </td>
                                    <!--<td class="u-heading-5 pt-2 pb-2">[{{totalDevices}}]</td>-->
                                  </tr>
                                  <tr>
                                    <adp-label labelKey="Dashboard_Devices_Component_Label"></adp-label>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="d-none d-sm-block dashboard-device-container">
                            <adp-image imageKey="Global_Dashboard_Devices_Image"></adp-image>
                          </div>
                          <div class="d-block d-sm-none dashboard-device-container">
                            <adp-image imageKey="Global_Dashboard_Devices_Mobile_Image"></adp-image>
                          </div>
                        </div>
                      </div>
                      <!--<mat-divider [vertical]="true"></mat-divider>-->
                      <div class="redirect-button" fxLayout="row" fxLayoutAlign="start center">
                        <a routerLink="{{ deviceRoute }}" [disabled]="isDisabledController" sf-aria-label="Global_GetStarted_Aria_Label">
                          <mat-icon [svgIcon]="'chevron-right-card-gray'"></mat-icon>
                        </a>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>

            <!-- PGH+Mobile Plan -->
            <ng-container *ngIf="isMobilePlan">
              <div class="d-flex pt-2 pb-2 pl-2 pr-0">
                <div class="d-flex">
                  <div class="d-flex flex-column align-items-center">
                    <div class="main-card-container">
                      <div style="display: flex">
                        <div class="w-100" style="display: flex">
                          <table class="w-100">
                            <tbody>
                              <tr>
                                <td class="u-heading-4 pt-2 pb-2">
                                  <adp-label labelKey="Dashboard_Devices_Heading"></adp-label>&nbsp;[{{ smartDevicesCount }}]
                                </td>
                              </tr>
                              <tr>
                                <adp-label labelKey="Dashboard_Devices_Component_Label"></adp-label>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="dashboard-device-container">
                        <adp-image imageKey="Global_Dashboard_Devices_Image"></adp-image>
                      </div>
                    </div>
                  </div>
                  <!--<mat-divider [vertical]="true"></mat-divider>-->
                  <div class="redirect-button" fxLayout="row" fxLayoutAlign="start center">
                    <a routerLink="{{ deviceRoute }}" [disabled]="isDisabledController" sf-aria-label="Global_GetStarted_Aria_Label">
                      <mat-icon [svgIcon]="'chevron-right-card-gray'"></mat-icon>
                    </a>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Right side components -->
      <div class="col-lg-5">
        <div class="d-flex flex-column" style="height: 100%">
          <!-- Account Management -->
          <div
            class="device-container"
            tabindex="0"
            (keypress)="handleAccountKeyDown($event)"
            (click)="goToAccountManagement()"
            [class.is-disabled]="(isExpired || isCancelled || !hasActiveAccount) && !cancelledOrExpiredHasFullAccess"
            [gtmClick]="getViewLabel('Dashboard_Account_Heading')"
            [gtmLinkURL]="accountManagementUrl">
            <div class="d-flex w-100 pt-3 pb-3 pl-3 pr-2">
              <div class="d-flex flex-column w-75 pl-3">
                <p class="u-heading-4 mb-1 font-weight-bold"><adp-label labelKey="Dashboard_Account_Heading"></adp-label></p>
                <!--<p class="u-body-3 mb-1 account-card-title"><adp-label labelKey="Dashboard_Account_Component_Text"></adp-label></p>-->
                <div>
                  <ul>
                    <li class="u-body-3 mb-1 account-card-list" *ngFor="let offer of benefitsOfferedList">
                      <adp-label [labelKey]="offer + '_Title'"></adp-label>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="d-flex justify-content-end w-25">
                <div class="d-flex">
                  <div class="redirect-button d-flex align-items-center">
                    <a routerLink="{{ accountManagementUrl }}" sf-aria-label="Global_View_Account">
                      <mat-icon [svgIcon]="'chevron-right-card-gray'"></mat-icon>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Tech Services Component -->
          <ng-container>
            <div ifSettingTrue="Dashboard_TechServices_Card_Visible">
              <div *ngIf="!isPTPO" class="mt-4">
                <div
                  class="device-container"
                  tabindex="0"
                  (keypress)="handleTechServicesKeyDown($event)"
                  (click)="goToTechServices()"
                  [class.is-disabled]="(isExpired || isCancelled || !hasActiveAccount) && !cancelledOrExpiredHasFullAccess"
                  [gtmClick]="getViewLabel('Dashboard_TechServices_Heading')"
                  [gtmLinkURL]="techServicesRoute">
                  <div class="d-flex w-100 pt-3 pb-3 pl-3 pr-2">
                    <div class="d-flex flex-column w-75 pl-3">
                      <p class="u-heading-4 mb-1 font-weight-bold"><adp-label labelKey="Dashboard_TechServices_Heading"></adp-label></p>
                      <!--<p class="u-body-3 mb-1"><adp-label labelKey="Dashboard_TechServices_Component_Text"></adp-label></p>-->
                      <div>
                        <ul>
                          <li class="u-body-3 mb-1" *ngFor="let offer of techServicesofferList">
                            <adp-label [labelKey]="offer + '_Title'"></adp-label>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end w-25">
                      <div class="d-flex">
                        <div class="redirect-button d-flex align-items-center">
                          <a
                            routerLink="{{ techServicesRoute }}"
                            sf-aria-label="Global_TechServices_Aria_Label"
                            sf-aria-label="Global_View_TechServices">
                            <mat-icon [svgIcon]="'chevron-right-card-gray'"></mat-icon>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- Support Center Component -->
          <adp-setting key="Support_Offered"></adp-setting>
          <adp-setting key="Support_Offered_Primary"></adp-setting>
          <adp-setting key="Support_Offered_Secondary"></adp-setting>
          <ng-container *ngIf="isSupportOffered">
            <div class="mt-4" ifSettingTrue="Global_SupportCenter_Services_Enabled">
              <div
                class="device-container"
                tabindex="0"
                (keypress)="handleSupportCenterKeyDown($event)"
                (click)="supportCenterButtonClick()"
                [class.is-disabled]="(isExpired || isCancelled || !hasActiveAccount) && !cancelledOrExpiredHasFullAccess"
                [gtmClick]="getViewLabel('Dashboard_SupportCenter_Heading')"
                [gtmLinkURL]="supportCenterComponentRoute">
                <div class="d-flex w-100 pt-3 pb-3 pl-3 pr-2">
                  <div class="d-flex flex-column w-75 pl-3">
                    <p class="u-heading-4 mb-1 font-weight-bold"><adp-label labelKey="Dashboard_SupportCenter_Heading"></adp-label></p>
                    <!--<p class="u-body-3 mb-1 support-center-card-title"><adp-label labelKey="Dashboard_SupportCenter_Component_Text"></adp-label></p>-->
                    <div>
                      <ul class="list-items">
                        <li class="u-body-3 mb-1 support-center-card-list" *ngFor="let offer of supportCenterOfferedServicesList">
                          <div><adp-label [labelKey]="offer + '_DisplayText'"></adp-label></div>
                          <div class="suplimental-text"><adp-label [labelKey]="offer + '_SupplimentalText'"></adp-label></div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end w-25">
                    <div class="d-flex">
                      <div class="redirect-button d-flex align-items-center">
                        <a
                          href="javascript:void(0);"
                          (click)="supportCenterButtonClick()"
                          role="button"
                          sf-aria-label="Global_View_SupportCenter">
                          <mat-icon [svgIcon]="'chevron-right-card-gray'"></mat-icon>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4" ifSettingFalse="Global_SupportCenter_Services_Enabled" style="flex-grow: 1">
              <div class="device-container-nosupport" tabindex="0">
                <div class="d-flex w-100 pt-3 pb-3 pl-3 pr-2">
                  <div class="d-flex flex-column w-100 pl-3">
                    <p class="u-heading-4 mb-1 font-weight-bold">
                      <adp-label labelKey="Global_FileClaim_Heading"></adp-label>
                    </p>
                    <div style="padding: 20px">
                      <adp-label labelKey="Global_FileClaim_Subheading"></adp-label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- Chat -->
    <div class="row margin-top-mobile">
      <adp-setting key="Dashboard_Promo_IsEnabled"></adp-setting>
      <adp-setting key="Dashboard_AppTypePromo_IsEnabled"></adp-setting>
      <adp-setting key="Dashboard_AppTypePromo_GooglePlay_IsEnabled"></adp-setting>
      <adp-setting key="Dashboard_AppTypePromo_AppleStore_IsEnabled"></adp-setting>
      <adp-setting key="Dashboard_AppTypePromo_QRCode_IsEnabled"></adp-setting>
      <adp-setting key="Dashboard_Promo_IsPromoAppType"></adp-setting>
      <ng-container>
        <div ifSettingTrue="Dashboard_AppTypePromo_IsEnabled">
          <app-apptype-promotion-panel [divider]="true" [promoSlot]="promoDashboardAppTypeSlot" *ngIf="!isSuspended">
          </app-apptype-promotion-panel>
        </div>
      </ng-container>
      <ng-container *ngIf="isTechServicesChatEnabled">
        <div [ngClass]="!isPTPO ? 'col-12 order-md-3 promo-container' : 'col-lg-6 order-md-2'" ifSettingTrue="Dashboard_Promo_IsEnabled">
          <app-promotion-panel
            [isPromoBackFill]="true"
            [divider]="true"
            [isDisabledController]="(isExpired || isCancelled) && !cancelledOrExpiredHasFullAccess"
            [isPTPO]="isPTPO"
            [promoSlot]="promoDashboardSlot"
            gaName="Dashboard Promotional Panel">
          </app-promotion-panel>
        </div>
      </ng-container>
    </div>
  </div>
  <!-- Perks -->

  <adp-setting key="Dashboard_Perks_Primary"></adp-setting>
  <adp-setting key="Dashboard_Perks_Secondary"></adp-setting>
  <div class="perks-container" [ngClass]="[disableCntrl ? 'is-disabled' : '']">
    <div class="container">
      <pgh-call-to-action-section></pgh-call-to-action-section>
    </div>
  </div>
  <!-- Disclaimer -->
  <app-disclaimer-section *ngIf="showDisclaimer"></app-disclaimer-section>
</div>
</ng-container>


<!--  SPOE Dashboard  -->
<ng-container *ngIf="isSPOEEnabled">
  <div>
    <app-notice-banner *ngFor="let noticeBanner of noticeBanners;let i=index"
    [isVisible]="bannersVisibility[i]"
    [noticeBanner]="noticeBanner"
    [isExternalUrl]="isCancelled"
    [isPrimary]="isPrimary"
    >
  </app-notice-banner>
  <!-- TODO Need to determine if this component is needed for SPOE -->
  <!--<app-dashboard-hero
    [disableAccount]="(isExpired || isCancelled) && !cancelledOrExpiredHasFullAccess"
    [notifyPhonesPending]="isPhonesStatusPending"
    [notifyPhonesFailed]="isPhonesStatusFailed">
  </app-dashboard-hero>-->
  <pgh-upgrade-callout *ngIf="isPTPO" [upgradeBanner]="upgradeBanner"></pgh-upgrade-callout>
    <div class="dashboard-container container" style="margin-top:150px;margin-bottom:50px;">
      <div class="row cards-container">
        <div class="col-lg-12" style="display:flex;flex-direction: column;">
          <ng-container *ngIf="!isMobileSize">
            <div class="cards-container-styles" style="min-height:462px;">
            <div class="cards-outer-container col-lg-6 col-md-12 col-sm-12 col-xs-12">
              <div class="cards-text-container">
                <div>
                  <h1 class="cards-text-title"><adp-label labelKey="SPOE_Dashboard_Heading_Title"></adp-label></h1>
                </div>
                <div class="cards-text-description"><adp-label labelKey="SPOE_Dashboard_Heading_Description"></adp-label></div>
              </div>
              <div class="button-outer-container">
                <button mat-flat-button color="accent" style="max-width:244px;" (click)="goToClaims()" [gtmClick]="getViewLabel('Global_Button_Claims')" gtmLinkURL="/device-select">
                  <adp-label labelKey="Global_Button_Claims"></adp-label>
                </button>
              </div>
            </div>
            <div class="dashboard-background-image col-lg-6" [ngStyle]="{'background-image': 'url(' + claimsBackgroundImageURL + ')'}"></div>
            </div>
          </ng-container>
          <ng-container *ngIf="isMobileSize">
            <div class="dashboard-background-mobile-image col-lg-12" [ngStyle]="{'min-height':'179px;','min-width':'100%;','background-image': 'url(' + claimsBackgroundImageURL + ')'}"></div>
            <div class="cards-container-styles" style="flex-direction:row;border-top-left-radius: 0px;border-top-right-radius: 0px;">
            <div class="cards-outer-mobile-container col-lg-6 col-md-12 col-sm-12 col-xs-12">
              <div class="cards-text-container">
                <div><h1 class="cards-text-title"><adp-label labelKey="SPOE_Dashboard_Heading_Title"></adp-label></h1></div>
                <div class="cards-text-description"><adp-label labelKey="SPOE_Dashboard_Heading_Description"></adp-label></div>
              </div>
              <div class="button-outer-container">
                <button mat-flat-button color="accent" class="dashboard-button-mobile-accent" (click)="goToClaims()" [gtmClick]="getViewLabel('Global_Button_Claims')" gtmLinkURL="/device-select">
                  <adp-label labelKey="Global_Button_Claims"></adp-label>
                </button>
              </div>
            </div>
            </div>
          </ng-container>

        <!-- COVERAGE PLANS -->
          <div>
            <div class="dashboard-outer-container-heading-title">
              <adp-label labelKey="Dashboard_Coverage_Plans_Title"></adp-label>
            </div>
            <div *ngIf="hasMultiPolicies" style="display:flex;justify-content: space-between;">
              <div class="coverage-outer-container">
                <ng-container *ngTemplateOutlet="coverageMobileItemsTemplate"></ng-container>
                <ng-container *ngTemplateOutlet="coverageHomeItemsTemplate"></ng-container>
              </div>
            </div>
            <div *ngIf="!hasMultiPolicies && isMobileSize" style="display:flex;justify-content: space-between;">
              <div class="coverage-outer-container">
                <div *ngIf="hasP360MobilePolicy"><ng-container *ngTemplateOutlet="coverageMobileItemsTemplate"></ng-container></div>
                <div *ngIf="hasP360HomeTechPolicy"><ng-container *ngTemplateOutlet="coverageHomeItemsTemplate"></ng-container></div>
              </div>
            </div>
            <div *ngIf="!hasMultiPolicies && !isMobileSize" class="cards-container-styles" style="background-color: #fff;">
              <ng-container>
                <div class="cards-outer-container col-lg-6 col-md-12 col-sm-12 col-xs-12" style="max-width:154px;background-color: #F8FAFB;">
                  <div class="button-outer-container" style="align-items: center;display:flex;">
                    <!-- ICON GOES HERE -->
                    <mat-icon *ngIf="hasP360MobilePolicy" class="coverage-mobile-icon-container"><ng-container *ngTemplateOutlet="coverageSingleMobileIcon"></ng-container></mat-icon>
                    <mat-icon *ngIf="hasP360HomeTechPolicy" class="coverage-home-icon-container" svgIcon="coverageHomeIcon"></mat-icon>
                  </div>
                </div>
                <div class="cards-outer-container col-lg-6" style="flex-grow: 1;background-color: #FFF;">
                  <div class="cards-text-container">
                    <div *ngIf="hasP360MobilePolicy">
                      <div class="cards-container-styles-heading-xl"><adp-label labelKey="Global_Eprism_Product_Name"></adp-label></div>
                      <div style="color:#3D515A;font-size:16px;font-weight: 400; line-height:normal;margin-top:25px;"><adp-label labelKey="Dashboard_Coverage_Mobile_Description"></adp-label></div>
                      <!--<div style="color:#13223C;font-size:16px;font-weight: 600; margin-top: 25px;margin-bottom: 15px;"><adp-label labelKey="Dashboard_Coverage_CoveredFor_Title"></adp-label></div>
                      <div style="gap:10px;display:flex;flex-direction: column;">
                        <div style="display:flex;">
                          <div style="display:flex;">
                            <div class="coverage-svg-container">
                               <ng-container *ngFor="let listItem of this.coverageMobilePlanList; odd as isOdd; even as isEven;">
                                  <div style="display:flex;" *ngIf="isEven">
                                    <div><mat-icon class="coverage-bullet-icon-container"><ng-container *ngTemplateOutlet="coverageBulletIcon"></ng-container></mat-icon></div>
                                    <div><adp-label [labelKey]="listItem"></adp-label></div>
                                  </div>
                                </ng-container>
                            </div>
                          </div>
                          <div style="display:flex;">
                            <div class="coverage-svg-container">
                                <ng-container *ngFor="let listItem of this.coverageMobilePlanList; odd as isOdd; even as isEven;">
                                <div style="display:flex;" *ngIf="isOdd">
                                  <div><mat-icon class="coverage-bullet-icon-container"><ng-container *ngTemplateOutlet="coverageBulletIcon"></ng-container></mat-icon></div>
                                  <div><adp-label [labelKey]="listItem"></adp-label></div>
                                </div>
                                </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>-->
                      <div style="flex-grow:1;display:flex;">
                        <div class="coverage-container-view-details">
                          <a routerLink="/coverage-mobile" [gtmClick]="getViewLabel('Dashboard_Coverage_ViewDetails_Text')" gtmLinkURL="/coverage-mobile">
                            <adp-label labelKey="Dashboard_Coverage_ViewDetails_Text"></adp-label>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="hasP360HomeTechPolicy">
                      <div class="cards-container-styles-heading-xl"><adp-label labelKey="Global_Product_Name"></adp-label></div>
                      <div style="color:#3D515A;font-size:16px;font-weight: 400; line-height:normal;margin-top:25px;"><adp-label labelKey="Dashboard_Coverage_Home_Description"></adp-label></div>
                      <!--<div class="coverage-bullet-list-title"><adp-label labelKey="Dashboard_Coverage_CoveredFor_Title"></adp-label></div>
                      <div style="gap:10px;display:flex;flex-direction: column;">
                        <div style="display:flex;">
                          <div style="display:flex;">
                            <div class="coverage-svg-container">
                              <ng-container *ngFor="let listItem of this.coverageHomePlanList; odd as isOdd; even as isEven;">
                                  <div style="display:flex;" *ngIf="isEven">
                                    <div><mat-icon class="coverage-bullet-icon-container"><ng-container *ngTemplateOutlet="coverageBulletIcon"></ng-container></mat-icon></div>
                                    <div><adp-label [labelKey]="listItem"></adp-label></div>
                                  </div>
                                </ng-container>
                            </div>
                          </div>
                          <div style="display:flex;">
                            <div class="coverage-svg-container">
                              <ng-container *ngFor="let listItem of this.coverageHomePlanList; odd as isOdd; even as isEven;">
                                <div style="display:flex;" *ngIf="isOdd">
                                  <div><mat-icon class="coverage-bullet-icon-container"><ng-container *ngTemplateOutlet="coverageBulletIcon"></ng-container></mat-icon></div>
                                  <div><adp-label [labelKey]="listItem"></adp-label></div>
                                </div>
                                </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>-->
                      <div style="flex-grow:1;display:flex;">
                        <div class="coverage-container-view-details">
                          <a routerLink="/coverage-home" [gtmClick]="getViewLabel('Dashboard_Coverage_ViewDetails_Text')" gtmLinkURL="/coverage-home">
                            <adp-label labelKey="Dashboard_Coverage_ViewDetails_Text"></adp-label>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

        <!-- DEVICES -->
          <ng-container *ngIf="isMobileSize">
            <div class="dashboard-background-mobile-image col-lg-12" style="margin-top:40px;" [ngStyle]="{'min-height':'139px;','min-width':'100%;','background-image': 'url(' + devicesBackgroundImageURL + ')'}"></div>
            <div class="cards-container-styles" style="flex-direction:row;border-top-left-radius: 0px;border-top-right-radius: 0px;">
              <div class="cards-outer-mobile-container col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="cards-text-container">
                  <div class="cards-container-styles-heading-xl"><adp-label labelKey="Dashboard_Devices_Heading_Title"></adp-label></div>
                  <div class="cards-container-styles-description"><adp-label labelKey="Dashboard_Devices_Heading_Description"></adp-label></div>
                </div>
                <div class="button-outer-container">
                  <button mat-flat-button color="accent" class="dashboard-button-mobile-accent" (click)="goToMyDevices()" [gtmClick]="getViewLabel('Global_Button_ViewDevices')" [gtmLinkURL]="deviceRoute">
                    <adp-label labelKey="Global_Button_ViewDevices"></adp-label>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isMobileSize">
            <div class="cards-container-styles" style="margin-top:40px;">
              <div class="devices-cards-outer-container col-lg-6 col-md-12 col-sm-12 col-xs-12" style="max-width:500px;">
                <div class="cards-text-container">
                  <div class="cards-container-styles-heading-xl"><adp-label labelKey="Dashboard_Devices_Heading_Title"></adp-label></div>
                  <div class="cards-container-styles-description"><adp-label labelKey="Dashboard_Devices_Heading_Description"></adp-label></div>
                </div>
                <div class="button-outer-container">
                  <button mat-flat-button color="accent" style="max-width:244px;" (click)="goToMyDevices()" [gtmClick]="getViewLabel('Global_Button_ViewDevices')" [gtmLinkURL]="deviceRoute">
                    <adp-label labelKey="Global_Button_ViewDevices"></adp-label>
                  </button>
                </div>
              </div>
              <div class="dashboard-background-image" style="width:100%;" [ngStyle]="{'background-image': 'url(' + devicesBackgroundImageURL + ')'}"></div>
            </div>
          </ng-container>

        <!-- SUPPORT -->
          <div class="dashboard-outer-container-heading-title">
            <adp-label labelKey="Dashboard_Support_Heading_Title"></adp-label>
          </div>
          <ng-container *ngIf="isMobileSize">
            <div class="support-background-mobile-image col-lg-12" [ngStyle]="{'min-height':'139px;','min-width':'100%;','background-image': 'url(' + chatSupportBackgroundImageURL + ')'}"></div>
            <div class="support-inner-card-mobile-container" style="flex-direction:row;background:#fff;">
              <div class="cards-outer-mobile-container col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="cards-text-container">
                  <div class="cards-container-styles-heading"><adp-label labelKey="Dashboard_Support_Chat_Heading_Title"></adp-label></div>
                  <div class="cards-container-styles-description"><adp-label labelKey="Dashboard_Support_Chat_Heading_Description"></adp-label></div>
                </div>
                <div class="button-outer-container">
                  <button mat-stroked-button color="accent" style="font-weight:600;" (click)="goToChat()"><adp-label labelKey="Global_Button_Chat_TechSupport"></adp-label></button>
                </div>
              </div>
            </div>
            <div class="support-background-mobile-image col-lg-12" style="margin-top:20px;" [ngStyle]="{'min-height':'139px;','min-width':'100%;','background-image': 'url(' + techServicesSupportBackgroundImageURL + ')'}"></div>
            <div class="support-inner-card-mobile-container" style="flex-direction:row;background:#fff;">
              <div class="cards-outer-mobile-container col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="cards-text-container">
                  <div class="cards-container-styles-heading"><adp-label labelKey="Dashboard_Support_TechServices_Heading_Title"></adp-label></div>
                  <div class="cards-container-styles-description"><adp-label labelKey="Dashboard_Support_TechServices_Heading_Description"></adp-label></div>
                </div>
                <div class="button-outer-container">
                  <button mat-stroked-button color="accent" style="font-weight:600;" (click)="goToTechServices()" [gtmClick]="getViewLabel('Global_Button_View_TechServices')" [gtmLinkURL]="techServicesRoute">
                    <adp-label labelKey="Global_Button_View_TechServices"></adp-label>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isMobileSize">
            <div style="display:flex;gap:20px;justify-content: space-between;width:100%;">
              <div style="display:flex;width:50%;">
                <div class="cards-container-styles" style="background:#fff;">
                  <div class="support-background-image" style="width:159px;" [ngStyle]="{'background-image': 'url(' + chatSupportBackgroundImageURL + ')'}"></div>
                  <div class="support-outer-container col-lg-6 col-md-12 col-sm-12 col-xs-12" style="flex-grow: 1;max-height: 224px;">
                    <div class="cards-text-container">
                      <div class="cards-container-styles-heading"><adp-label labelKey="Dashboard_Support_Chat_Heading_Title"></adp-label></div>
                      <div class="cards-container-styles-description"><adp-label labelKey="Dashboard_Support_Chat_Heading_Description"></adp-label></div>
                    </div>
                    <div class="button-outer-container">
                      <button mat-stroked-button color="accent" style="font-weight:600;max-width:244px;" (click)="goToChat()"><adp-label labelKey="Global_Button_Chat_TechSupport"></adp-label></button>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display:flex;width:50%;">
                <div class="cards-container-styles" style="background:#fff;">
                  <div class="support-background-image" style="width:159px;" [ngStyle]="{'background-image': 'url(' + techServicesSupportBackgroundImageURL + ')'}"></div>
                  <div class="support-outer-container col-lg-6 col-md-12 col-sm-12 col-xs-12" style="flex-grow: 1;max-height: 224px;">
                    <div class="cards-text-container">
                      <div class="cards-container-styles-heading"><adp-label labelKey="Dashboard_Support_TechServices_Heading_Title"></adp-label></div>
                      <div class="cards-container-styles-description"><adp-label labelKey="Dashboard_Support_TechServices_Heading_Description"></adp-label></div>
                    </div>
                    <div class="button-outer-container">
                      <button mat-stroked-button color="accent" style="font-weight:600;max-width:244px;" (click)="goToTechServices()" [gtmClick]="getViewLabel('Global_Button_View_TechServices')" [gtmLinkURL]="techServicesRoute">
                        <adp-label labelKey="Global_Button_View_TechServices"></adp-label>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

        <!-- FAQ -->
          <ng-container *ngIf="!hasMultiPolicies">
            <div class="dashboard-outer-container-heading-title"><adp-label labelKey="Dashboard_FAQ_Heading_Title"></adp-label></div>
            <div style="display:flex;margin-bottom:15px;">
              <div class="cards-container-styles-description-xl"><adp-label labelKey="Dashboard_FAQ_Heading_Description"></adp-label></div>
              <div class="faq-container-viewall-link">
                <a *ngIf="hasP360HomeTechPolicy" [routerLink]="['/faq']" [gtmClick]="getViewLabel('Global_Button_ViewAll_FAQs')" [gtmLinkURL]="'/faq'" ><adp-label labelKey="Global_Button_ViewAll_FAQs"></adp-label>
                </a>
                <a *ngIf="hasP360MobilePolicy" [routerLink]="['/p360-faq']" [gtmClick]="getViewLabel('Global_Button_ViewAll_FAQs')" [gtmLinkURL]="'/p360-faq'" ><adp-label labelKey="Global_Button_ViewAll_FAQs"></adp-label>
                </a>
              </div>
            </div>
            <div>
              <div *ngIf="hasP360HomeTechPolicy">
                <pgh-spoe-dashboard-faq [faqImageKey]="'Global_SPOE_Dashboard_HomeTech_FAQ_Image_Desktop'" [faqListItems]="this.homePlanFAQListItems"></pgh-spoe-dashboard-faq>
              </div>
              <div *ngIf="hasP360MobilePolicy">
                <pgh-spoe-dashboard-faq [faqImageKey]="'Global_SPOE_Dashboard_FAQ_Image_Desktop'" [faqListItems]="this.mobilePlanFAQListItems"></pgh-spoe-dashboard-faq>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="hasMultiPolicies">
            <div style="display:flex;justify-content:center;margin-top:60px;color:#13223C;font-size:32px; font-weight: 600; line-height:normal;margin-bottom:16px;"><adp-label labelKey="Dashboard_FAQ_Heading_Title"></adp-label></div>
            <div class="support-tab-container">
              <!-- TODO remove animations/transitions to the tab body element if requested -->
              <mat-tab-group>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <adp-label style="font-size:16px;font-weight:600;" labelKey="Global_Eprism_Product_Name" [gtmClick]="getViewLabel('Global_Eprism_Product_Name')"></adp-label>
                  </ng-template>
                  <div style="display:flex;margin-bottom:15px;">
                    <div class="cards-container-styles-description-xl"><adp-label labelKey="Dashboard_FAQ_Heading_Description"></adp-label></div>
                    <div class="faq-container-viewall-link">
                      <a [routerLink]="['/p360-faq']" [gtmClick]="getViewLabel('Global_Button_ViewAll_FAQs')" [gtmLinkURL]="'/p360-faq'"><adp-label labelKey="Global_Button_ViewAll_FAQs"></adp-label></a>
                    </div>
                  </div>
                  <div>
                    <pgh-spoe-dashboard-faq [faqImageKey]="'Global_SPOE_Dashboard_FAQ_Image_Desktop'" [faqListItems]="this.mobilePlanFAQListItems"></pgh-spoe-dashboard-faq>
                  </div>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <adp-label style="font-size:16px;font-weight:600;" labelKey="Global_Product_Name" [gtmClick]="getViewLabel('Global_Product_Name')"></adp-label>
                  </ng-template>
                  <div style="display:flex;margin-bottom:15px;">
                    <div class="cards-container-styles-description-xl"><adp-label labelKey="Dashboard_FAQ_Heading_Description"></adp-label></div>
                    <div class="faq-container-viewall-link"><a routerLink="/faq" [gtmClick]="getViewLabel('Global_Button_ViewAll_FAQs')" gtmLinkURL="/faq"><adp-label labelKey="Global_Button_ViewAll_FAQs"></adp-label></a></div>
                  </div>
                  <div>
                    <pgh-spoe-dashboard-faq [faqImageKey]="'Global_SPOE_Dashboard_HomeTech_FAQ_Image_Desktop'" [faqListItems]="this.homePlanFAQListItems"></pgh-spoe-dashboard-faq>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <ng-template #coverageMobileItemsTemplate>
    <div class="coverage-multi-box-container">
      <ng-container>
        <div class="cards-outer-container col-lg-12" style="padding:0px;border-top-right-radius: 8px;border-top-left-radius:8px;height:50px;background:#F8FAFB;"></div>
        <div class="coverage-inner-container col-lg-12" style="flex-grow:1;">
          <div class="cards-text-container">
            <div style="display:flex;align-items:center;">
              <div><mat-icon style="height:40px;width:50px;overflow:visible !important;" svgIcon="coverageMobileIcon"></mat-icon></div>
              <div class="cards-container-styles-heading"><adp-label labelKey="Global_Eprism_Product_Name"></adp-label></div>
            </div>
            <div class="cards-container-styles-description"><adp-label labelKey="Dashboard_Coverage_Mobile_Description"></adp-label></div>
          </div>
          <!--<div class="coverage-bullet-list-title"><adp-label labelKey="Dashboard_Coverage_CoveredFor_Title"></adp-label></div>
          <div style="gap:10px;display:flex;flex-direction: column;">
            <div *ngFor="let listItem of this.coverageMobilePlanList">
              <div style="display:flex;">
                <div><mat-icon class="coverage-bullet-icon-container"><ng-container *ngTemplateOutlet="coverageBulletIcon"></ng-container></mat-icon></div>
                <div><adp-label [labelKey]="listItem"></adp-label></div>
              </div>
            </div>
          </div>-->
          <div style="flex-grow:1;display:flex;">
            <div class="coverage-container-view-details">
              <a routerLink="/coverage-mobile" [gtmClick]="getViewLabel('Dashboard_Coverage_ViewDetails_Text')" gtmLinkURL="/coverage-mobile">
              <adp-label labelKey="Dashboard_Coverage_ViewDetails_Text"></adp-label>
              </a>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
  <ng-template #coverageHomeItemsTemplate>
    <div class="coverage-multi-box-container">
      <ng-container>
        <div class="cards-outer-container col-lg-12" style="padding:0px;border-top-right-radius: 8px;border-top-left-radius:8px;height:50px;background:#F8FAFB;"></div>
        <div class="coverage-inner-container col-lg-12" style="flex-grow:1;">
          <div class="cards-text-container">
            <div style="display:flex;align-items:center;">
              <div><mat-icon style="height:40px;width:50px;overflow:visible !important;" svgIcon="coverageHomeIcon"></mat-icon></div>
              <div style="margin-left:10px;color:#13223C;font-size:24px; font-weight: 600; line-height:normal"><adp-label labelKey="Global_Product_Name"></adp-label></div>
            </div>
            <div class="cards-container-styles-description"><adp-label labelKey="Dashboard_Coverage_Home_Description"></adp-label></div>
          </div>
          <!--<div class="coverage-bullet-list-title"><adp-label labelKey="Dashboard_Coverage_CoveredFor_Title"></adp-label></div>
          <div style="gap:10px;display:flex;flex-direction: column;">
            <div *ngFor="let listItem of this.coverageHomePlanList">
              <div style="display:flex;">
                <div><mat-icon class="coverage-bullet-icon-container"><ng-container *ngTemplateOutlet="coverageBulletIcon"></ng-container></mat-icon></div>
                <div><adp-label [labelKey]="listItem"></adp-label></div>
              </div>
            </div>
          </div>-->
          <div style="flex-grow:1;display:flex;">
            <div class="coverage-container-view-details">
              <a routerLink="/coverage-home" [gtmClick]="getViewLabel('Dashboard_Coverage_ViewDetails_Text')" gtmLinkURL="/coverage-home">
                <adp-label labelKey="Dashboard_Coverage_ViewDetails_Text"></adp-label>
              </a>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
  <ng-template #coverageBulletIcon>
    <svg width="21" height="25" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 22.7201C10 22.7201 18 18.5761 18 12.3601V5.10802L10 2L2 5.10802V12.3601C2 18.5761 10 22.7201 10 22.7201Z" stroke="#3C4D6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </ng-template>
  <ng-template #coverageSingleMobileIcon>
    <svg width="68" height="86" viewBox="0 0 68 86" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M45.1173 68.5242C44.8256 68.5242 44.5368 68.4448 44.2842 68.2859L32.8651 61.1078C27.93 58.008 24.0625 51.1958 24.0625 45.6002V25.2259C24.0625 24.6162 24.4775 24.0745 25.091 23.8816L44.6391 17.7359C44.9489 17.6395 45.2827 17.6395 45.5894 17.7359L60.9031 22.5515C61.691 22.7983 62.1151 23.6009 61.8534 24.3439C61.5918 25.087 60.7467 25.4869 59.9527 25.2401L45.1143 20.5776L27.0699 26.2498V45.6002C27.0699 50.1862 30.4863 56.21 34.5312 58.7511L45.1173 65.4045L55.6973 58.7511C59.7422 56.2071 63.1586 50.1862 63.1586 45.6002V37.3274C63.1586 36.5447 63.8323 35.9094 64.6623 35.9094C65.4924 35.9094 66.166 36.5447 66.166 37.3274V45.6002C66.166 51.1958 62.2985 58.008 57.3634 61.1107L45.9503 68.2888C45.6977 68.4448 45.409 68.5242 45.1173 68.5242Z" fill="#E20074"/>
    <path d="M45.1048 48.6722C44.7198 48.6722 44.3349 48.5333 44.0401 48.2582L35.018 39.75C34.4315 39.1969 34.4315 38.2979 35.018 37.7449C35.6044 37.1918 36.5577 37.1918 37.1442 37.7449L45.1048 45.2491L65.0919 26.4006C65.6783 25.8476 66.6317 25.8476 67.2181 26.4006C67.8046 26.9536 67.8046 27.8527 67.2181 28.4057L46.1664 48.2582C45.8747 48.5333 45.4897 48.6722 45.1048 48.6722Z" fill="#E20074"/>
    <path d="M25.558 79.8688H22.5506C21.7205 79.8688 21.0469 79.2335 21.0469 78.4507C21.0469 77.668 21.7205 77.0327 22.5506 77.0327H25.558C26.388 77.0327 27.0617 77.668 27.0617 78.4507C27.0617 79.2335 26.388 79.8688 25.558 79.8688Z" fill="#E20074"/>
    <path d="M31.5797 8.96741H16.5428C15.7127 8.96741 15.0391 8.33213 15.0391 7.54938C15.0391 6.76663 15.7127 6.13135 16.5428 6.13135H31.5797C32.4098 6.13135 33.0834 6.76663 33.0834 7.54938C33.0834 8.33213 32.4098 8.96741 31.5797 8.96741Z" fill="#E20074"/>
    <path d="M40.5998 85.541H7.51849C3.3743 85.541 0 82.3589 0 78.4508V7.54915C0 3.64105 3.3743 0.458984 7.51849 0.458984H40.5998C44.744 0.458984 48.1183 3.64105 48.1183 7.54915V13.2213C48.1183 14.004 47.4447 14.6393 46.6146 14.6393C45.7846 14.6393 45.1109 14.004 45.1109 13.2213V7.54915C45.1109 5.20372 43.0869 3.29505 40.5998 3.29505H7.51849C5.03137 3.29505 3.00739 5.20372 3.00739 7.54915V78.4508C3.00739 80.7962 5.03137 82.7049 7.51849 82.7049H40.5998C43.0869 82.7049 45.1109 80.7962 45.1109 78.4508V72.7787C45.1109 71.9959 45.7846 71.3606 46.6146 71.3606C47.4447 71.3606 48.1183 71.9959 48.1183 72.7787V78.4508C48.1183 82.3589 44.744 85.541 40.5998 85.541Z" fill="#E20074"/>
    </svg>
  </ng-template>
</ng-container>
